import { useEffect } from 'react';
import { usePullToRefreshRegistry } from './PullToRefreshContext';

// Registra la funzione di refresh della pagina corrente per il pull-to-refresh (solo app nativa).
// `handler` può restituire una Promise (lo spinner resta finché non si risolve) oppure nulla
// (lo spinner mostra un tempo minimo). Le pagine che non registrano nulla ricadono sul reload.
// Avvolgere l'handler in useCallback per evitare register/unregister ad ogni render.
export const useRefreshHandler = (handler) => {
    const registry = usePullToRefreshRegistry();
    useEffect(() => {
        if (!registry) return undefined;
        registry.register(handler);
        return () => registry.unregister(handler);
    }, [registry, handler]);
};
